export default __webpack_public_path__ + "static/africaprize-1f4e6f72554c8e080cf944945519a5b8.png";